import {
  ApplicationRef,
  Injectable,
} from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { PusherService } from './pusher.service';

@Injectable()
export class NotificationsService {
  private channels = {};

  constructor(
    private applicationRef: ApplicationRef,
    private pusherService: PusherService,
  ) {}

  channel(channelName): Observable<any> {
    let channel = this.channels[channelName];
    if (!channel) {
      const subject = new Subject<any>();
      const subscription = this.pusherService.pusher.subscribe(channelName);
      subscription.bind('events', data => {
        subject.next(data);
        this.applicationRef.tick();
      });
      channel = this.channels[channelName] = {
        subscription: subscription,
        subject: subject,
      };
    }
    return channel['subject'];
  }
}
